import { Component, Input } from '@angular/core';

import type { CoroButtonType } from '@core-app/coro/components/coro-button/coro-button.type';

@Component({
    selector: 'core-coro-button',
    templateUrl: './coro-button.component.html',
    styleUrl: './coro-button.component.scss',
    standalone: false,
})
export class CoroButtonComponent {
    @Input() button!: CoroButtonType;
}
